import { PlayerShortLink } from "./PlayerShortLink";
import { PricePlanTier, SocialNetworksId } from "../../../interfaces";
import { SocialIdentity } from "@/services/bedrock";

export namespace User {
  export enum Type {
    ADMIN = "ADMIN",
    EDITOR = "EDITOR",
    PLAYER = "PLAYER",
    COACH = "COACH",
    ENTERPRISE_COACH = "ENTERPRISE_COACH",
    SYSTEM_ADMIN = "SYSTEM_ADMIN",
    ASSISTANT_COACH = "ASSISTANT_COACH",
  }
}

export interface User {
  id: number;
  username?: string | null;
  email: string | null;
  status?: string | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  phone: string | null;
  photoUrl: string | null;
  userGroups?: User.Type[];
}

export interface UserAccount {
  id: number;
  userId: number;
  guid: string;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  email: string | null;
  phone: string | null;
  photoUrl: string | null;
  complianceDisclaimer?: string | null;
}

export interface VideoProjectCreditsStatus {
  hasVideoProjectAccess: boolean;
  creditsUsed: number;
  creditsRemaining: number;
  creditsAllotted: number;
  unlimitedCredits: boolean;
}

export interface Player extends UserAccount {
  // Extra fields that are returned from the server if requested
  hasPlayerCard?: boolean;
  playerCardUrl?: string | null;
  regionNames?: string[] | null;
  branchNames?: string[] | null;
  allowPlayerAccessToPlayerCardsPermission?: boolean;
  webAddress?: string | null;
  shortLink?: PlayerShortLink;
  aliases?: string[];
  industryRoles?: PlayerSegmentation[];
  videoProjectCreditsStatus?: VideoProjectCreditsStatus;
}

export interface Coach extends UserAccount {}

export type PlayerPlanStatus = "CANCELED" | "ACTIVE" | "FREE_TRIAL" | "INACTIVE" | "PENDING_PAYMENT";
export type PlayerSegmentationType = "STATE" | "REGION" | "BRANCH" | "COST_CENTER" | "INDUSTRY_ROLE";
export type PlayerSearchSort = "first_name" | "last_name" | "email" | "created_date" | "last_login_date";
export type PlayerSearchDir = "asc" | "desc";

export interface PlayerSearchQuery {
  searchTerm?: string;
  segmentationIds?: (number | string)[];
  planTiers?: PricePlanTier[];
  planStatuses?: PlayerPlanStatus[];
  playerIds?: number[];
  playerIdsOrSegmentation?: boolean;
  sort?: PlayerSearchSort;
  sortDirection?: PlayerSearchDir;
  page?: number;
  perPage?: number;
}

export interface PlayerSegmentation {
  id: number;
  name: string;
  type: PlayerSegmentationType;
}

interface PlayerSocialAccount {
  id: number;
  socialNetworkId: SocialNetworksId;
  socialIdentity?: SocialIdentity;
}

export interface PlayerSearchResult {
  id: number;
  guid: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
  phone?: string;
  photoUrl?: string;
  complianceDisclaimer?: string;
  internalIdentifier?: string;
  tier?: PricePlanTier;
  planStatus: PlayerPlanStatus;
  segmentationDetails: PlayerSegmentation[];
  activeSocialNetworkProfiles: PlayerSocialAccount[];

  createdDate: string;
  canceledAt: string;
  verificationDate: string;
  lastLoginDate: string;
}
